
export function checkMatch(outType, typeRequired, isFirstLevel){

  if (typeRequired.t === 'toDelete' || outType.t === 'toDelete'){
    return false;
  }else if (typeRequired.t === 'ListType' && outType.t === 'ListType'){
    return checkMatch(outType.c, typeRequired.c, false);
  }else if (typeRequired.t === 'MaybeSpecified' && outType.t === 'MaybeSpecified'){
    return checkMatch(outType.c[0], typeRequired.c[0], false);
  }else if (typeRequired.t === 'Object' && outType.t === 'Object'){
    if (outType.c.length === typeRequired.c.length){
      for (var i = 0; i < outType.c.length; i++){
        var anO = outType.c[i];
        var haveFound = false;
        for (var j = 0; j < typeRequired.c.length; j++){
          var aO = typeRequired.c[j];
          if (anO.n === aO.n){
            var c = checkMatch(anO.t, aO.t, false);
            if (!c){
              return false;
            }
            haveFound = true;
            break;
          }
        }
        if (!haveFound){
          return false;
        }
      }
      return true;
    }else{
      return false;
    }
  }else if (outType.t !== 'Panel' && typeRequired.t === 'Panel' && isFirstLevel){
    return false;
  }else if (outType.t !== 'ScEvent' && typeRequired.t === 'ScEvent' && isFirstLevel){
    return false;
  // }else if (outType.t !== 'Screen' && typeRequired.t === 'Screen'){
  //   return false;
  }else if (outType.t !== 'MaybeSpecified' && typeRequired.t === 'MaybeSpecified'){
    return false;
  }else if (typeRequired.t === outType.t){
    return true;
  }else if (typeRequired.t === 'any' || typeRequired.t === 'free' || outType.t === 'any'){ 
    return true;
  }else if (outType.t === 'nos'){
    if (typeRequired.t === 'Integer' || typeRequired.t === 'UInteger' || typeRequired.t === 'Decimal'){
      return true;
    }
  }else if (typeRequired.t === 'nos'){
    if (outType.t === 'Integer' || outType.t === 'Decimal' || outType.t === 'UInteger'){
      return true;
    }
  }
  return false;
}

